module.exports = __webpack_public_path__ + "static/media/IMG_4417.651df17a.JPG";